import React, { useState, forwardRef, useEffect, useMemo, useRef, }  from 'react'
import { 
  useTable, 
  usePagination, 
  useRowSelect, 
  useFilters, 
  useGlobalFilter, 
  useAsyncDebounce, 
  useGroupBy, 
  useExpanded } from 'react-table'
import { setSelectedSOPs, useSelectedSOPs, useTags } from '../redux/plan'
import {matchSorter} from 'match-sorter'
import {
  Paper, IconButton,
  TablePagination, 
  Checkbox,
} from '@material-ui/core'
import { 
  Cancel, 
  SubdirectoryArrowRight, 
  KeyboardArrowUp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
  FirstPage,
  AddCircleOutline } from '@material-ui/icons'
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles'
import Badge from '@material-ui/core/Badge'
import _ from 'lodash'
const checkBoxStyles = theme => ({
  root: {
    color: 'rgb(244, 152, 30)',
    '&$checked': {
      color: 'rgb(244, 152, 30)',
    },
  },
  checked: {},
 })
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);
function TagCell({ value, ...props}) {
  const cleanArray = _.compact(value)
  const strVal = cleanArray.join()
  return <>{strVal.slice(0,15)}</>
}

const IndeterminateCheckbox = forwardRef(
  ({ indeterminate, row, ...rest }, ref) => {
    const selected = useSelectedSOPs()
    const defaultRef = useRef()
    const resolvedRef = ref || defaultRef
    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])
    return (
        (!row?.isGrouped && typeof row !== 'undefined') ?
        <CustomCheckbox
            inputProps={{ 'aria-label': 'select all desserts' }}
            ref={resolvedRef}
            {...rest}
            onChange={ (e) => {
              if(!row.isExpanded){
                if(e.target.checked){
                  const nSelected = [ ...selected ]
                  if(!selected.some( cRow => cRow._id === row.original._id ))
                    nSelected.push(row.original)
                  const sortedNewSelectedSOPs = _.sortBy(nSelected, item => _.findIndex(selected, sel => item._id === sel._id));
                  setSelectedSOPs(sortedNewSelectedSOPs);
                }
                else{
                  const nSelected = [...selected]
                  _.remove( nSelected, itm => (itm._id === row.original._id) )
                  setSelectedSOPs(nSelected)
                }
              }
              rest.onChange(e)
            }}
        />
        : <div ref={resolvedRef}></div>
    )
  }
)

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length
  const [value, setValue] = useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)

  return (
    <span>
      Search:{' '}
      <input
        value={value || ""}
        onChange={e => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`${count} records...`}
        style={{
          fontSize: '1.1rem',
          border: '0',
        }}
      />
    </span>
  )
}

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length

  return (
    <input
      width={1/4}
      value={filterValue || ''}
      onChange={e => {
        
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
    />
  )
}


function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const tags = useTags();
  const tagId = id.split('.')[1]
  const options = useMemo(() => {
    return tags[tagId]
  }, [id, preFilteredRows]) || []

  // Render a multi-select box
  return (
    <select
      style={{width:100}}
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  )
}


function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = val => !val

const customFilter = (rows, id, filterValue) => {
  return rows.filter(row => {
    const rowTags = row.values[id[0]]
    if( typeof rowTags === 'string')
      return rowTags.trim().toLocaleLowerCase() === filterValue.toLowerCase()
    else if( typeof rowTags === 'undefined' )
      return false
    else
      return rowTags.some( tag => tag ? tag.trim().toLowerCase() == filterValue.toLowerCase() : false )
  });
}

const StyledBadge = withStyles((theme) => ({
  badge: {
    left: -10,
    top: 10,
  },
}))(Badge);

export default function DataTable ({datos, ...props}){
  
  const [refreshRowSelection, setRefreshRowSelection] = useState(true) 
  const selected = useSelectedSOPs()
  const data = useMemo( () => datos, [] )
  const columns = useMemo(
    () => [
      {
        Header: 'Title',
        accessor: 'title', // accessor is the "key" in the data
      },
      {
        Header: 'Audit requirement',
        accessor: 'humantags.AR',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
      {
        Header: 'Location',
        accessor: 'humantags.LOC',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
      {
        Header: 'Type of doc',
        accessor: 'humantags.DOC',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
      {
        Header: 'Process',
        accessor: 'humantags.PR',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
      {
        Header: 'Ingredients type',
        accessor: 'humantags.ING',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
      {
        Header: 'Process step',
        accessor: 'humantags.PRS',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
      {
        Header: 'Equipment',
        accessor: 'humantags.EQU',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
      {
        Header: 'Pkg. Mat. type',
        accessor: 'humantags.PAC',
        Cell: TagCell,
        Filter: SelectColumnFilter,
        filter: customFilter,
      },
    ],
    [])

    const filterTypes = useMemo(
      () => ({
        // Add a new fuzzyTextFilterFn filter type.
        fuzzyText: fuzzyTextFilterFn,
        // Or, override the default text filter to use
        // "startWith"
        text: (rows, id, filterValue) => {
          return rows.filter(row => {
            const rowValue = row.values[id]
            return rowValue !== undefined
              ? String(rowValue)
                  .toLowerCase()
                  .startsWith(String(filterValue).toLowerCase())
              : true
          })
        },
      }),
      []
    )
  
  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    toggleRowSelected,
    getRowProps,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    visibleColumns,
    state,
    state: { pageIndex, pageSize, selectedRowIds, selectedFlatRows, groupBy, expanded },
  } = useTable(
      { 
        columns, data, defaultColumn, filterTypes , 
        autoResetSelectedRows: false,
      },
      useFilters,
      useGlobalFilter,
      useGroupBy,
      useExpanded,
      usePagination,
      useRowSelect,
      hooks => {
        hooks.visibleColumns.push(columns => [
          // Let's make a column for selection
          {
            id: 'selection',
            // The header can use the table's getToggleAllRowsSelectedProps method
            // to render a checkbox
            Header: ({ getToggleAllPageRowsSelectedProps }) => (
              <div>
                <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
              </div>
            ),
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) => {
              return (
              <div>
                <IndeterminateCheckbox row={row} {...row.getToggleRowSelectedProps()} />
              </div>
            )},
          },
          ...columns,
        ])
      }
      )


  const checkTickedRows = () => {
    rows.forEach(({ id, original, subRows }) => {
      if(typeof original !== 'undefined')
        if (selected.some( el => el._id === original._id ) ) {
          toggleRowSelected(id, original.isSelected);
        }
    });
  }
  useEffect( () => {
    checkTickedRows()
    // if(refreshRowSelection)
    //   checkTickedRows()
    // else
    //   setRefreshRowSelection(true)
  // }, [rows, toggleRowSelected])
  }, [])

  function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;
  
    const handleFirstPageButtonClick = (event) => {
      gotoPage(0)
    };
  
    const handleBackButtonClick = (event) => {
      previousPage()
    };
  
    const handleNextButtonClick = (event) => {
      nextPage()
    };
  
    const handleLastPageButtonClick = (event) => {
      gotoPage(pageCount -1)
    };
  
    return (
      <div className={classes.root} width={1}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPage /> : <FirstPage />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPage /> : <LastPage />}
        </IconButton>
      </div>
    );
  }

  return (
    <Paper elevation={3} >
          <style>{`
            table {
              border-collapse: collapse;
              width:100%;
              font-size:medium;
            }
            thead th:nth-child(1) {
              width: 1%;
            }
            thead th {
              width: 15%;
              font-size: small;
              padding-top: 15px;
              padding-bottom: 10px;
            }
            tbody tr:nth-child(odd) {
              background-color: #e9ecef;
            }
            tbody td {
              text-align: left;
            }

          `}</style>
          <table {...getTableBodyProps()} >
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th {...column.getHeaderProps()}>
                      <div>{column.canFilter && column.render('Filter') }</div>
                      <StyledBadge 
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }} 
                        badgeContent={
                          column.canGroupBy && (
                            <span {...column.getGroupByToggleProps()}>
                              {column.isGrouped ? <Cancel fontSize="small" /> : <AddCircleOutline fontSize="small" />}
                            </span>
                          )
                        } >
                        {column.render('Header')}
                      </StyledBadge>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return(
                        <td {...cell.getCellProps()} >
                          {cell.isGrouped ? (
                            // If it's a grouped cell, add an expander and row count
                            <>
                              <span {...row.getToggleRowExpandedProps()}>
                                {row.isExpanded ? <KeyboardArrowUp /> : <SubdirectoryArrowRight /> }
                              </span>{' '}
                              {cell.render('Cell')} ({row.subRows.length})
                            </>
                          ) : cell.isAggregated ? (
                            // If the cell is aggregated, use the Aggregated
                            // renderer for cell
                            cell.render('Aggregated')
                          ) : cell.isPlaceholder ? null : ( // For cells with repeated values, render null
                            // Otherwise, just render the regular cell
                            cell.render('Cell')
                          )}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            component="div"
            count={rows.length}
            rowsPerPage={pageSize}
            page={pageIndex + 1}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            onChangePage={ e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            onChangeRowsPerPage={ e => {setPageSize(Number(e.target.value))}}
            ActionsComponent={TablePaginationActions}
          />
    </Paper>
  )
}